import { Action } from '@ngrx/store';
import { ExtJiraConfigModel } from '@smarttask-common/src/lib/models/Integrations/Jira/Config/ExtJiraConfigModel';

export enum ExtJiraConfigActionTypes {
    UPSERT_EXT_JIRA_CONFIG = '[ExtJiraConfig] Upsert ExtJiraConfig',
    UPSERT_EXT_JIRA_CONFIGS = '[ExtJiraConfig] Upsert ExtJiraConfigs',
    DELETE_EXT_JIRA_CONFIG = '[ExtJiraConfig] Delete ExtJiraConfig',
    DELETE_EXT_JIRA_CONFIGS = '[ExtJiraConfig] Delete ExtJiraConfigs',
}

export class UpsertOne implements Action {
    readonly type = ExtJiraConfigActionTypes.UPSERT_EXT_JIRA_CONFIG;
    constructor(public config: ExtJiraConfigModel) {}
}

export class UpsertMany implements Action {
    readonly type = ExtJiraConfigActionTypes.UPSERT_EXT_JIRA_CONFIGS;
    constructor(public configs: Array<ExtJiraConfigModel>) {}
}

export class DeleteOne implements Action {
    readonly type = ExtJiraConfigActionTypes.DELETE_EXT_JIRA_CONFIG;
    constructor(public config_id: string) {}
}

export class DeleteMany implements Action {
    readonly type = ExtJiraConfigActionTypes.DELETE_EXT_JIRA_CONFIGS;
    constructor(public config_ids: Array<string>) {}
}

export type ExtJiraConfigActions = UpsertOne | UpsertMany | DeleteOne | DeleteMany;
